

export const frontMatter = {
	title: 'Configurer une connexion WebSocket',
	sidebar_label: 'Connexion WebSocket',
	sidebar_position: 1,
	tags: [
		'javascript'
	],
	keywords: [
		'js',
		'websocket-connection'
	],
	description: 'Un guide sur la façon d\'établir une connexion WebSocket à une API WebSocket sur votre application de trading.'
};
export const contentTitle = undefined;
export const metadata = {
  "id": "languages/javascript/websocket-connection/index",
  "title": "Configurer une connexion WebSocket",
  "description": "Un guide sur la façon d'établir une connexion WebSocket à une API WebSocket sur votre application de trading.",
  "source": "@site/i18n/fr/docusaurus-plugin-content-docs/current/languages/javascript/websocket-connection/index.md",
  "sourceDirName": "languages/javascript/websocket-connection",
  "slug": "/languages/javascript/websocket-connection/",
  "permalink": "/fr/docs/languages/javascript/websocket-connection/",
  "draft": false,
  "unlisted": false,
  "tags": [
    {
      "label": "javascript",
      "permalink": "/fr/docs/tags/javascript"
    }
  ],
  "version": "current",
  "lastUpdatedAt": 1748500809000,
  "sidebarPosition": 1,
  "frontMatter": {
    "title": "Configurer une connexion WebSocket",
    "sidebar_label": "Connexion WebSocket",
    "sidebar_position": 1,
    "tags": [
      "javascript"
    ],
    "keywords": [
      "js",
      "websocket-connection"
    ],
    "description": "Un guide sur la façon d'établir une connexion WebSocket à une API WebSocket sur votre application de trading."
  },
  "sidebar": "tutorialSidebar",
  "previous": {
    "title": "Configuration du projet",
    "permalink": "/fr/docs/languages/javascript/project-setup/"
  },
  "next": {
    "title": "Obtenir une liste de pays",
    "permalink": "/fr/docs/languages/javascript/get-country-list/"
  }
};
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [{
  "value": "Configurer une connexion WebSocket",
  "id": "configurer-une-connexion-websocket",
  "level": 3
}, {
  "value": "Envoyer et recevoir des données",
  "id": "envoyer-et-recevoir-des-données",
  "level": 3
}, {
  "value": "Garder la connexion WebSocket active",
  "id": "garder-la-connexion-websocket-active",
  "level": 3
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    admonition: "admonition",
    code: "code",
    h3: "h3",
    li: "li",
    p: "p",
    pre: "pre",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.admonition, {
      type: "caution",
      children: _jsxs(_components.p, {
        children: ["Si vous n'êtes pas familier avec les WebSockets, veuillez consulter ", _jsx(_components.a, {
          href: "/docs/core-concepts/websocket",
          children: "notre documentation"
        }), "."]
      })
    }), "\n", _jsx(_components.h3, {
      id: "configurer-une-connexion-websocket",
      children: "Configurer une connexion WebSocket"
    }), "\n", _jsx(_components.p, {
      children: "Ensuite, nous allons créer une connexion WebSocket au serveur WebSocket de Deriv comme indiqué ci-dessous :"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-js",
        metastring: "title=\"index.js\" showLineNumbers",
        children: "const app_id = 1089; // Remplacez par votre app_id ou laissez 1089 pour les tests.\nconst websocket = new WebSocket(`wss://ws.derivws.com/websockets/v3?app_id=${app_id}`);\n"
      })
    }), "\n", _jsx(_components.admonition, {
      type: "info",
      children: _jsxs(_components.p, {
        children: [_jsx(_components.code, {
          children: "app_id = 1089"
        }), " est juste à des fins de test. Veuillez mettre cela à jour avec votre propre app_id lorsque vous publiez votre application dans un environnement de production. Veuillez consulter ", _jsx(_components.a, {
          href: "/docs/setting-up-a-deriv-application",
          children: "ce guide"
        }), " pour créer une nouvelle application pour vous-même."]
      })
    }), "\n", _jsxs(_components.p, {
      children: ["À ce stade, nous sommes connectés au ", _jsx(_components.code, {
        children: "WebSocket server"
      }), ". Mais nous ne recevons aucune donnée. Pour envoyer ou recevoir des données, nous devons nous ", _jsx(_components.code, {
        children: "abonner"
      }), " aux ", _jsx("a", {
        href: "https://developer.mozilla.org/en-US/docs/Web/API/WebSocket#events",
        target: "_blank",
        children: "websocket events"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["En général, nous avons 4 événements sur les ", _jsx(_components.code, {
        children: "WebSocket connections"
      }), " :"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "close"
        }), " :\nDéclenché lorsqu'une connexion avec une WebSocket est fermée. Également disponible au moyen de la propriété onclose."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "open"
        }), " :\nDéclenché lorsqu'une connexion avec une WebSocket est ouverte. Également disponible au moyen de la propriété onopen."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "message"
        }), " :\nDéclenché lorsque des données sont reçues par l'intermédiaire d'une WebSocket. Également disponible au moyen de la propriété onmessage."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "error"
        }), " :\nDéclenché lorsqu'une connexion avec une WebSocket a été fermée en raison d'une erreur, par exemple lorsque des données n'ont pas pu être envoyées. Également disponible au moyen de la propriété onerror."]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Ajoutons un écouteur d'événements pour ces événements sur notre connexion WebSocket."
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-js",
        metastring: "title=\"index.js\" showLineNumbers",
        children: "// s'abonner à l'événement `open`\nwebsocket.addEventListener('open', (event) => {\n  console.log('connexion websocket établie: ', event);\n});\n\n// s'abonner à l'événement `message`\nwebsocket.addEventListener('message', (event) => {\n  console.log('nouveau message reçu du serveur: ', event);\n});\n\n// s'abonner à l'événement `close`\nwebsocket.addEventListener('close', (event) => {\n  console.log('connexion websocket fermée: ', event);\n});\n\n// s'abonner à l'événement `error`\nwebsocket.addEventListener('error', (event) => {\n  console.log('une erreur est survenue dans notre connexion websocket', event);\n});\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Maintenant, ouvrez le fichier ", _jsx(_components.code, {
        children: "index.html"
      }), " dans notre navigateur et vérifiez votre console de développement. Vous ne devriez voir que le journal pour ", _jsx(_components.code, {
        children: "connexion websocket établie"
      }), "."]
    }), "\n", _jsx(_components.h3, {
      id: "envoyer-et-recevoir-des-données",
      children: "Envoyer et recevoir des données"
    }), "\n", _jsxs(_components.p, {
      children: ["Notre serveur WebSocket offre la fonctionnalité ", _jsx("a", {
        href: "/api-explorer#ping",
        target: "_blank",
        rel: "noopener noreferrer",
        children: "ping/pong."
      }), " Utilisons cela dans notre projet démo pour envoyer et recevoir des données. Utilisons cela dans notre projet démo pour envoyer et recevoir des données. Modifiez les récepteurs d'événements pour ", _jsx(_components.code, {
        children: "open"
      }), " et ", _jsx(_components.code, {
        children: "message"
      }), " comme suit :"]
    }), "\n", _jsx(_components.admonition, {
      type: "caution",
      children: _jsxs(_components.p, {
        children: ["La fonction ", _jsx(_components.code, {
          children: "send"
        }), " de la connexion WebSocket ne reçoit que des ", _jsx(_components.code, {
          children: "string"
        }), ", ", _jsx(_components.code, {
          children: "ArrayBuffer"
        }), ", ", _jsx(_components.code, {
          children: "Blob"
        }), ", ", _jsx(_components.code, {
          children: "TypedArray"
        }), " et ", _jsx(_components.code, {
          children: "DataView"
        }), ". Pour en savoir plus, consultez le site ", _jsx(_components.a, {
          href: "https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send",
          children: "MDN"
        }), ". Cela signifie que si nous voulons envoyer un ", _jsx(_components.code, {
          children: "objet"
        }), ", nous devons d'abord le filtrer avec ", _jsx(_components.code, {
          children: "JSON.stringify"
        }), "."]
      })
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-js",
        metastring: "title=\"index.js\" showLineNumbers",
        children: "// s'abonner à l'événement `open`\nwebsocket.addEventListener('open', (event) => {\n  console.log('connexion websocket établie: ', event);\n  const sendMessage = JSON.stringify({ ping: 1 });\n  websocket.send(sendMessage);\n});\n\n// s'abonner à l'événement `message`\nwebsocket.addEventListener('message', (event) => {\n  const receivedMessage = JSON.parse(event.data);\n  console.log('nouveau message reçu du serveur: ', receivedMessage);\n});\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Le ", _jsx(_components.code, {
        children: "receivedMessage"
      }), " serait un objet comme celui-ci :"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-js",
        metastring: "showLineNumbers",
        children: "{\n  echo_req: {\n      ping: 1\n  },\n  msg_type: \"ping\",\n  ping: \"pong\"\n}\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Félicitations ", "🎉"]
    }), "\n", _jsx(_components.p, {
      children: "Vous avez créé votre premier projet démo avec WebSockets."
    }), "\n", _jsx(_components.admonition, {
      type: "tip",
      children: _jsxs(_components.p, {
        children: ["La requête ", _jsx(_components.code, {
          children: "ping"
        }), " est principalement utilisée pour tester la connexion ou pour la maintenir en vie."]
      })
    }), "\n", _jsx(_components.h3, {
      id: "garder-la-connexion-websocket-active",
      children: "Garder la connexion WebSocket active"
    }), "\n", _jsxs(_components.p, {
      children: ["Par défaut, les ", _jsx(_components.code, {
        children: "connexions WebSocket"
      }), " seront fermées si aucun trafic n'est envoyé entre elles pendant environ ", _jsx(_components.strong, {
        children: "180 secondes"
      }), ". Une façon de maintenir la connexion en vie est d'envoyer des requêtes ", _jsx(_components.a, {
        href: "/api-explorer#ping",
        children: "ping"
      }), " à des intervalles de ", _jsx(_components.strong, {
        children: "120 secondes"
      }), ". Cela permettra de garder la connexion active."]
    }), "\n", _jsx(_components.p, {
      children: "Voici un exemple de configuration simple :"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-js",
        metastring: "title=\"index.js\" showLineNumbers",
        children: "const ping_interval = 12000; // c'est en millisecondes, ce qui équivaut à 120 secondes\nlet interval;\nwebsocket.addEventListener('open', (event) => {\n  console.log('connexion websocket établie: ', event);\n  const sendMessage = JSON.stringify({ ping: 1 });\n  websocket.send(sendMessage);\n\n  // pour garder la connexion active\n  interval = setInterval(() => {\n    const sendMessage = JSON.stringify({ ping: 1 });\n    websocket.send(sendMessage);\n  }, ping_interval);\n});\n\n// subscribe to `close` event\nwebsocket.addEventListener('close', (event) => {\n  console.log('connexion websocket fermée: ', event);\n  clearInterval(interval);\n});\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Maintenant, quand la connexion est ", _jsx(_components.code, {
        children: "établie"
      }), ", nous commençons à envoyer des requêtes ", _jsx(_components.code, {
        children: "ping"
      }), " avec des intervalles de ", _jsx(_components.code, {
        children: "12000ms"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "Votre code final devrait ressembler à ceci :"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-js",
        metastring: "title=\"index.js\" showLineNumbers",
        children: "const app_id = 1089; // Remplacez par votre app_id ou laissez 1089 pour les tests.\nconst websocket = new WebSocket(`wss://ws.derivws.com/websockets/v3?app_id=${app_id}`);\nconst ping_interval = 12000; // c'est en millisecondes, ce qui équivaut à 120 secondes\nlet interval;\n\n// s'abonner à l'événement `open`\nwebsocket.addEventListener('open', (event) => {\n  console.log('connexion websocket établie: ', event);\n  const sendMessage = JSON.stringify({ ping: 1 });\n  websocket.send(sendMessage);\n\n  // pour garder la connexion active\n  interval = setInterval(() => {\n    const sendMessage = JSON.stringify({ ping: 1 });\n    websocket.send(sendMessage);\n  }, ping_interval);\n});\n\n// s'abonner à l'événement `message`\nwebsocket.addEventListener('message', (event) => {\n  const receivedMessage = JSON.parse(event.data);\n  console.log('nouveau message reçu du serveur: ', receivedMessage);\n});\n\n// s'abonner à l'événement `close`\nwebsocket.addEventListener('close', (event) => {\n  console.log('connexion websocket fermée: ', event);\n  clearInterval(interval);\n});\n\n// s'abonner à l'événement `error`\nwebsocket.addEventListener('error', (event) => {\n  console.log('une erreur est survenue dans notre connexion websocket', event);\n});\n"
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

